import type { ReactElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface VerifiedPublisherIconProps {
  isVerified: boolean;
  className?: string;
}

/**
 * Component for displaying verified publisher checkmark icon
 * Similar to Cursor's verified publisher UI
 */
export function VerifiedPublisherIcon({
  isVerified,
  className,
}: VerifiedPublisherIconProps): ReactElement {
  if (!isVerified) {
    return <span className={cn('w-4', className)} />;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <CheckCircle2
          className={cn('h-4 w-4 text-blue-600 dark:text-blue-400', className)}
          aria-label="Verified publisher"
        />
      </TooltipTrigger>
      <TooltipContent>Verified publisher</TooltipContent>
    </Tooltip>
  );
}
